/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ServiceAbonnementDto as OkEgisServiceModelsDtoServiceAbonnementDto } from '../models/OK/Egis/Service/Models/DTO/service-abonnement-dto';
import { UpdateServiceAbonnementRequestDto as OkEgisServiceModelsDtoUpdateServiceAbonnementRequestDto } from '../models/OK/Egis/Service/Models/DTO/update-service-abonnement-request-dto';
import { ProduktEnum as OkEgisServiceModelsEntitiesEnumsProduktEnum } from '../models/OK/Egis/Service/Models/Entities/Enums/produkt-enum';
import { UpdateTilvalgOnServiceabonnementRequest as OkEgisServiceModelsRequestUpdateTilvalgOnServiceabonnementRequest } from '../models/OK/Egis/Service/Models/Request/update-tilvalg-on-serviceabonnement-request';
import { UpdateServiceabonnementResponseDto as OkEgisServiceModelsResponseUpdateServiceabonnementResponseDto } from '../models/OK/Egis/Service/Models/Response/update-serviceabonnement-response-dto';

@Injectable({
  providedIn: 'root',
})
export class ServiceAbonnementService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAvailableAbonnements
   */
  static readonly GetAvailableAbonnementsPath = '/api/v1/ServiceAbonnement/GetAvailableAbonnements';

  /**
   * Returns a list of available abonnements for a specific produkt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableAbonnements()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableAbonnements$Response(params: {
    produktId?: OkEgisServiceModelsEntitiesEnumsProduktEnum;
    kundeTypeId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceAbonnementDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAbonnementService.GetAvailableAbonnementsPath, 'get');
    if (params) {
      rb.query('produktId', params.produktId, {});
      rb.query('kundeTypeId', params.kundeTypeId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceAbonnementDto>>;
      })
    );
  }

  /**
   * Returns a list of available abonnements for a specific produkt.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableAbonnements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableAbonnements(params: {
    produktId?: OkEgisServiceModelsEntitiesEnumsProduktEnum;
    kundeTypeId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoServiceAbonnementDto>> {

    return this.getAvailableAbonnements$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceAbonnementDto>>) => r.body as Array<OkEgisServiceModelsDtoServiceAbonnementDto>)
    );
  }

  /**
   * Path part for operation getAllAbonnements
   */
  static readonly GetAllAbonnementsPath = '/api/v1/ServiceAbonnement/GetAllAbonnements';

  /**
   * Returns a list of available abonnements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAbonnements()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAbonnements$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceAbonnementDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAbonnementService.GetAllAbonnementsPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceAbonnementDto>>;
      })
    );
  }

  /**
   * Returns a list of available abonnements.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllAbonnements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAbonnements(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoServiceAbonnementDto>> {

    return this.getAllAbonnements$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceAbonnementDto>>) => r.body as Array<OkEgisServiceModelsDtoServiceAbonnementDto>)
    );
  }

  /**
   * Path part for operation updateServiceabonnementdescription
   */
  static readonly UpdateServiceabonnementdescriptionPath = '/api/v1/ServiceAbonnement/UpdateServiceabonnementdescription';

  /**
   * Updates FakturaDescription on a serviceabonnement with contents of the dto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateServiceabonnementdescription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceabonnementdescription$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoUpdateServiceAbonnementRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseUpdateServiceabonnementResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAbonnementService.UpdateServiceabonnementdescriptionPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseUpdateServiceabonnementResponseDto>;
      })
    );
  }

  /**
   * Updates FakturaDescription on a serviceabonnement with contents of the dto.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateServiceabonnementdescription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceabonnementdescription(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoUpdateServiceAbonnementRequestDto
  }): Observable<OkEgisServiceModelsResponseUpdateServiceabonnementResponseDto> {

    return this.updateServiceabonnementdescription$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseUpdateServiceabonnementResponseDto>) => r.body as OkEgisServiceModelsResponseUpdateServiceabonnementResponseDto)
    );
  }

  /**
   * Path part for operation updateTilvalgOnServiceabonnement
   */
  static readonly UpdateTilvalgOnServiceabonnementPath = '/api/v1/ServiceAbonnement/UpdateTilvalgOnServiceabonnement';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTilvalgOnServiceabonnement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTilvalgOnServiceabonnement$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateTilvalgOnServiceabonnementRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceAbonnementDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAbonnementService.UpdateTilvalgOnServiceabonnementPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceAbonnementDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTilvalgOnServiceabonnement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTilvalgOnServiceabonnement(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateTilvalgOnServiceabonnementRequest
  }): Observable<OkEgisServiceModelsDtoServiceAbonnementDto> {

    return this.updateTilvalgOnServiceabonnement$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceAbonnementDto>) => r.body as OkEgisServiceModelsDtoServiceAbonnementDto)
    );
  }

}
